import { useMemo } from 'react';

import { useDefaultEvents } from '@Components/Grid';

export default function useEvents() {
  const { handleUpdateEntry } = useDefaultEvents()

  return useMemo(() => ({
    handleUpdateEntry,
  }), [handleUpdateEntry])
}
